<script setup lang="ts">
import { computed } from "vue";
const route = useRoute();
const page = usePage().value;
const parseDate = (dateString: string) => {
  const [day, month, year] = dateString.split("/").map(Number);
  return new Date(year, month - 1, day);
};

interface Article {
  tags: string[];
  published: string;
  title: string;
  color?: string; // Optional if not all articles have a color defined
  uri?: string;
  blogImage?: {
    url: string;
    width: number;
    height: number;
    alt?: string;
  };
}

const normalizeUri = (uri) => uri.replace(/^\//, "").toLowerCase();

const currentUri = normalizeUri(route.path);

console.log("Current URI:", currentUri); // Debugging line

const articles = computed<Article[]>(() => {
  return (page?.articles ?? [])
    .filter((article) => normalizeUri(article.uri) !== currentUri)
    .slice()
    .sort((a, b) => parseDate(b.published).getTime() - parseDate(a.published).getTime());
});
</script>

<template>
  <ul class="more-articles-wrap">
    <li v-for="(article, index) in articles.slice(0, 3)" :key="index" class="article">
      <NuxtLink :to="`/${article.uri}`" class="btn from-left">
        <div class="article-image">
          <NuxtPicture
            v-if="article?.blogImage"
            loading="lazy"
            :src="article?.blogImage?.url"
            :width="article?.blogImage?.width"
            :height="article?.blogImage?.height"
            :alt="article?.blogImage?.alt"
            sizes="sm:100vw md:50vw lg:600px"
          />
        </div>

        <div class="article-meta">
          <h3>{{ article?.title }}</h3>
          <p class="date">{{ article.published }}</p>
        </div>
      </NuxtLink>
    </li>
  </ul>
</template>
